import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import useIntegration from 'api/useIntegration';
import useProfiles from 'api/useProfiles';
import useFeatureFlags from 'api/useFeatureFlags';

import { EToasterStatus, showToast } from '../utils/showToast';

export const useProfilesManager = () => {
  const { publisherId } = useParams();
  const { getIntegration }: any = useIntegration(publisherId as string);
  const { toggleProfile } = useProfiles(publisherId as string);
  const [isProfilesFeatureFlagOn, setIsProfilesFeatureFlagOn] =
    useState<boolean>(false);
  const [isProfilesEnabled, setIsProfilesEnabled] = useState<boolean>(
    getIntegration.data?.isProfilesEnabled
  );
  const { featureFlags } = useFeatureFlags({ publisherId });
  const [isToggleInProgress, setIsToggleInProgress] = useState<boolean>(false);

  const toggleIntegrationProfiles = (isProfilesToggleOn: boolean) => {
    toggleProfile.mutate(
      {
        isEnabled: isProfilesToggleOn
      },
      {
        onSuccess: () => {
          showToast({
            message: 'Integration environment changed successfully',
            status: EToasterStatus.SUCCESS
          });
          getIntegration.refetch();
        },
        onError: () => {
          showToast({
            message: 'Failed to toggle profile',
            status: EToasterStatus.ERROR
          });
        },
        onSettled: () => setIsToggleInProgress(false)
      }
    );
  };

  useEffect(() => {
    if (!featureFlags) return;
    setIsProfilesFeatureFlagOn(
      featureFlags?.integration_profiles
    );
  }, [featureFlags]);

  useEffect(() => {
    if (!getIntegration.data) return;
    const isEnabled =
      getIntegration.data.isProfilesEnabled && isProfilesFeatureFlagOn;
    setIsProfilesEnabled(isEnabled);
  }, [getIntegration.data, isProfilesFeatureFlagOn]);

  return {
    toggleIntegrationProfiles,
    isToggleInProgress,
    isProfilesEnabled,
    isProfilesFeatureFlagOn
  };
};
